<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="mini"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'
export default {
  props: {
    mrpFabricPlanCode: {
      type: String,
      default: '',
    },
  },
  components: {
    PageMain,
    PageHeader,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
    }
  },
  mounted() {},
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .mrpFabricPlanDetailListApi({
          mrpFabricPlanCode: this.mrpFabricPlanCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
